var JSONdata = JSON.parse(JSON.stringify(require('../assets/environment-variables.json')));
export const environment = {
  production: false,
  redirectUrl: 'https://dasaua.devapps.alcoa.com',
  //redirectUrl: 'http://localhost:4200',

  clientId: JSONdata["dev"]["clientId"],
  
  tenantId: JSONdata["dev"]["tenantId"],
  
  authority: 'https://login.microsoftonline.com/37a72eb7-1faf-49d3-9ddc-6b923b751bc0/',
  WEBAPIURL: '/devapi',
  //WEBAPIURL: '/localapi',
  //WEBAPIURL: 'https://localhost:44370',
  consentScopes: ["user.read"],
  scope: ["api://c218f03e-beb3-4212-ab54-34152fe77f1a.alcoa.com/user_impersonation"],
  AssetMaintenancePostSubscriptionKey: JSONdata["dev"]["AssetMaintenancePostSubscriptionKey"],

  FileUploadSize:20971520,

  AssetMaintenanceAPIUrl: '/assetmaintenance/entityName/',
  OracleDasAPIUrl: '/oraclemas/entityName/',
  AssetMaintenanceSubscriptionKey: JSONdata["dev"]["AssetMaintenanceSubscriptionKey"],
  
  AssetMaintenanceKey: JSONdata["dev"]["AssetMaintenanceKey"]
  
};

